import { ExternalLink } from 'lucide-react';

// Custom Social Icons
const FacebookIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const InstagramIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <img 
              src="/images/heise-wellness-logo.png" 
              alt="Heise Wellness" 
              className="h-12 lg:h-14 w-auto"
            />
            <p className="text-gray-400 leading-relaxed">
              Elite framing for women seeking collaborators in their healing journey.
            </p>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="text-lg font-medium uppercase tracking-wide text-gray-300">
              Contact
            </h4>
            <div className="space-y-2">
              <a
                href="mailto:jessica@heisewellness.com"
                className="block text-gray-400 hover:text-white transition-colors duration-300"
              >
                jessica@heisewellness.com
              </a>
              <a
                href="tel:708-774-0063"
                className="block text-gray-400 hover:text-white transition-colors duration-300"
              >
                708-774-0063
              </a>
            </div>
          </div>

          {/* Client Portal */}
          <div className="space-y-4">
            <h4 className="text-lg font-medium uppercase tracking-wide text-gray-300">
              Client Access
            </h4>
            <a
              href="#"
              className="inline-flex items-center space-x-2 text-purple-400 hover:text-purple-300 transition-colors duration-300"
            >
              <span>Client Portal</span>
              <ExternalLink size={16} />
            </a>
            <p className="text-sm text-gray-500">
              Access notes and billing
            </p>
          </div>

          {/* Follow Me */}
          <div className="space-y-4">
            <h4 className="text-lg font-medium uppercase tracking-wide text-gray-300">
              Follow Me
            </h4>
            <div className="flex items-center space-x-4">
              <a
                href="https://www.facebook.com/profile.php?id=61575996475883"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-300"
                aria-label="Facebook"
              >
                <FacebookIcon size={24} />
              </a>
              <a
                href="https://www.instagram.com/heise_wellness/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-300"
                aria-label="Instagram"
              >
                <InstagramIcon size={24} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} Heise Wellness. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;